export const notNullOrUndefined = <T>(v: T | null | undefined): v is T => v != null;
